export const tilebarConstants = [

    {
        tileName: "Quiz",
        id: 1,
        tilebarItemSetter: 'quiz',
        hidden: false,
        show_in_activation_phase: true,
        show_in_non_activation_phase : true,
    },
    {
        tileName: "Lessons",
        id: 2,
        tilebarItemSetter: 'next',
        hidden: true,
        show_in_activation_phase: true,
        show_in_non_activation_phase : true,
    },
    {
        tileName: "Overview",
        id: 3,
        tilebarItemSetter: 'overview',
        hidden: false,
        show_in_activation_phase: false,
        show_in_non_activation_phase : true,
    },
    {
        tileName: "Notes",
        id: 4,
        tilebarItemSetter: 'notes',
        hidden: false,
        show_in_activation_phase: false,
        show_in_non_activation_phase : true,
    },
    {
        tileName: "Doubts",
        id: 5,
        tilebarItemSetter: 'doubts',
        hidden: false,
        show_in_activation_phase: false,
        show_in_non_activation_phase : true,
    },
    {
        tileName: "Related",
        id: 6,
        tilebarItemSetter: 'related',
        hidden: false,
        show_in_activation_phase: false,
        show_in_non_activation_phase : true,
    },
    {
        tileName : "Milestones",
        id: 7,
        tilebarItemSetter : 'milestones',
        hidden : false,
        show_in_activation_phase: true,
        show_in_non_activation_phase : false,
    },
    {
        tileName : "Settings",
        id: 8,
        tilebarItemSetter : 'settings',
        show_in_activation_phase: true,
        show_in_non_activation_phase : false,
    }
    
]